import { render, staticRenderFns } from "./UserEditModalContent.vue?vue&type=template&id=880d3d2a&scoped=true"
import script from "./UserEditModalContent.vue?vue&type=script&lang=js"
export * from "./UserEditModalContent.vue?vue&type=script&lang=js"
import style0 from "./UserEditModalContent.vue?vue&type=style&index=0&id=880d3d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880d3d2a",
  null
  
)

export default component.exports